// extracted by mini-css-extract-plugin
export default {"decoration":"InUseDecoration_decoration__wlTpX"};